import { gettext } from '@eventbrite/i18n';
import { Checkbox } from '@eventbrite/marmalade';
import {
    FOLLOWED_ORGS_FILTER_VALUE,
    SPECIAL_FILTER,
} from '@eventbrite/search-utils';
import { setAction } from '@eventbrite/user-action-cookie';
import React, { FunctionComponent, useContext } from 'react';
import OverlayContext from '../../../../context/Overlay';
import { SelectedFilters } from '../../../../types/index';
import './EventsFilter.scss';

export interface FollowedOrganizersFilterButtonProps {
    selectedFilters?: SelectedFilters;
    onFilterChange?: Function;
    handleRemoveFilter?: Function;
    isAuthenticated?: boolean;
    isMobile?: boolean;
    signinConfirmationModalContent: FunctionComponent;
}

const FollowedOrganizersFilterButton = ({
    onFilterChange,
    handleRemoveFilter,
    isMobile,
    isAuthenticated,
    selectedFilters,
    signinConfirmationModalContent,
}: FollowedOrganizersFilterButtonProps) => {
    const { setOverlayConfig } = useContext(OverlayContext) || {};
    const loggedInHandleClick = () => {
        !selectedFilters?.followedOrganizers
            ? onFilterChange?.(SPECIAL_FILTER, FOLLOWED_ORGS_FILTER_VALUE)
            : handleRemoveFilter?.({ special: true });
    };

    const loggedOutHandleClick = () => {
        setAction({
            action: 'FollowedOrganizerFilterAttempt',
            origin: '/',
        });

        setOverlayConfig?.({
            type: 'simple',
            children: signinConfirmationModalContent,
        });
    };

    return (
        <div className="filterContainer">
            <Checkbox
                id={`followedOrganizersFilterButton__${
                    isMobile ? 'mobile' : 'desktop'
                }`}
                name={`followedOrganizersFilterButton__${
                    isMobile ? 'mobile' : 'desktop'
                }`}
                value={`followedOrganizers__${isMobile ? 'mobile' : 'desktop'}`}
                onChange={
                    isAuthenticated ? loggedInHandleClick : loggedOutHandleClick
                }
                className="checkBox"
                checked={selectedFilters?.followedOrganizers}
                aria-label={gettext('Show events from followed organizers')}
            />
            <div className="filterText">
                {gettext('Only show events from organizers I follow')}
            </div>
        </div>
    );
};

export default FollowedOrganizersFilterButton;
